const errorHandler = (err: any, reject: (reason?: any) => void) => {
    console.log(`An api error occurred: ${err.message} and message: ` + err.response?.data?.['message'])
    reject({...err.response?.data, status: err.response?.status})
}
export default errorHandler